import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { useState } from "react";
import { CancelDialog } from "./CancelDialog";
import { useTranslation } from "../../../../../../hooks/useTranslation";

export const CancelButton = () => {
  const [cancelDialogOpen, setCancelDialogOpen] = useState<boolean>(false);
  const { translate } = useTranslation(
    "pages.orders.detail.sidebar.orderCancel",
  );
  return (
    <>
      <ListItemButton
        onClick={() => {
          setCancelDialogOpen(true);
        }}
        sx={{ color: "error.main" }}
      >
        <ListItemIcon sx={{ color: "error.main" }}>
          <BlockIcon />
        </ListItemIcon>
        <ListItemText
          primary={translate("confirm")}
          primaryTypographyProps={{ color: "error", fontWeight: "bold" }}
        />
      </ListItemButton>

      <CancelDialog
        open={cancelDialogOpen}
        onClose={() => {
          setCancelDialogOpen(false);
        }}
      />
    </>
  );
};
